module.exports = __webpack_public_path__ + "static/media/qiansongni.c0203b07.png";